import script from "./DropdownTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownTrigger.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"DropdownTrigger.vue"]])

export default __exports__